var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 13.5443V11.4609H7.29427V8.33594L2.08594 12.5026L7.29427 16.6693V13.5443H16.6693Z",
    fill: "#26F2D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 3.125H11.4583C10.3094 3.125 9.375 4.05937 9.375 5.20833V9.375H11.4583V5.20833H20.8333V19.7917H11.4583V15.625H9.375V19.7917C9.375 20.9406 10.3094 21.875 11.4583 21.875H20.8333C21.9823 21.875 22.9167 20.9406 22.9167 19.7917V5.20833C22.9167 4.05937 21.9823 3.125 20.8333 3.125Z",
    fill: "#26F2D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut1);
export default __webpack_public_path__ + "static/media/log-out 1.55afdfb7c7cf87c186211d151cc86a60.svg";
export { ForwardRef as ReactComponent };